export enum ActiveTool {
  Select = 'Edit2DSelectTool',
  Calibration = 'Edit2DCalibrationTool',
  Measurement = 'Edit2DMeasurement',
  Drawing = 'Edit2DDrawing',
  DrainLine = 'Edit2DDrainLineTool',
  Wedge = 'Edit2DWedgeTool',
  Default = 'Edit2DSelectTool',
}
